import { type AvatarSize } from './constants/avatarSizes'
import { AvatarInitialsStyled } from './styles/AvatarInitialsStyled'
import { AvatarPhotoStyled } from './styles/AvatarPhotoStyled'
import { AvatarStyled, type AvatarViewingContext } from './styles/AvatarStyled'
import { getNameInitials } from './utils/getNameInitials'

export interface IAvatarProps {
  photoUrl?: string
  name?: string
  viewingContext?: AvatarViewingContext
  size?: AvatarSize
  shadow?: boolean
  /**
   * Hides the avatar from assistive tech. Use it when visible text beside the
   * avatar already names the person, so the name is not announced twice.
   */
  decorative?: boolean
}

export const Avatar = ({
  photoUrl,
  name,
  viewingContext = 'others',
  size = 'small',
  shadow,
  decorative = false,
}: IAvatarProps) => {
  return (
    <AvatarStyled
      $size={size}
      $shadow={shadow}
      $viewingContext={viewingContext}
      role={name && !decorative ? 'img' : undefined}
      aria-label={decorative ? undefined : name}
      aria-hidden={decorative || undefined}
    >
      <AvatarInitialsStyled aria-hidden='true' $size={size}>
        {getNameInitials(name)}
      </AvatarInitialsStyled>
      {photoUrl && (
        <AvatarPhotoStyled aria-hidden='true' $photoUrl={photoUrl} />
      )}
    </AvatarStyled>
  )
}

Avatar.displayName = 'Avatar'
